import React from 'react'
import TeamMemberCard from '../../molecules/TeamMemberCard'

interface TeamMember {
  _id: string
  name: string
  title: string
  order?: number
  image: {
    asset: {
      gatsbyImageData: any
    }
  }
}

interface TeamMembersSectionProps {
  heading?: string
  teamMembers?: TeamMember[]
}

const TeamMembersSection: React.FC<TeamMembersSectionProps> = ({ heading, teamMembers }) => {
  if (!teamMembers || teamMembers.length === 0) {
    return null
  }

  return (
    <section className="max-w-screen-xxl xl:w-9/12 mx-auto w-11/12 my-16">
      {heading && (
        <h2 className="text-3xl leading-10 font-normal font-montserrat mb-10 text-charcoal">{heading}</h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {teamMembers.map((member) => (
          <TeamMemberCard
            key={member._id}
            name={member.name}
            title={member.title}
            image={member.image}
          />
        ))}
      </div>
    </section>
  )
}

export default TeamMembersSection